













import Component, { mixins } from 'vue-class-component';

import Mixin from '@/mixins/image';

import ImageLink from '@/components/Atoms/Link/ImageLink.vue';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/FooterItem.vue';

@Component({
  components: {
    ListItem,
    ImageLink,
    UnorderedList,
  },
})
export default class FooterImageNav extends mixins(Mixin) {
  private links: {
    alt: string;
    link: string;
    fileName: string;
    selfWindow: boolean;
  }[] = [
    {
      alt: 'プライバシーマーク',
      link: 'https://privacymark.jp/',
      fileName: 'img_privacy.gif',
      selfWindow: false,
    },
    {
      alt: 'インターネット接続サービス安全・安心マーク',
      link: 'http://www.biglobe.ne.jp/safesecurity.html',
      fileName: 'img_security.gif',
      selfWindow: false,
    },
  ];
}
